import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints } from '../Constants';
import RequestHelper from '../RequestHelper';
import { fetchGameRooms } from '../../state/query/games/utils';
/**
 * Buy an item with an existing billing profile. Web version.
 * @param {Object} args
 * @param {String} args.ptype Type of purchase (currency, task, consumable)
 * @param {Number} args.currpkgid The SKU of the purchase
 * @param {Number} args.profile The billing profile which the players wishes to use.
 * @param {String} args.promocode Promo code to apply against the purchase.
 * @returns {Promise<import("../Constants").FinishWebPurchaseResponse>}
 */

function buyItemWithBillingProfile(_x) {
  return _buyItemWithBillingProfile.apply(this, arguments);
}

function _buyItemWithBillingProfile() {
  _buyItemWithBillingProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return RequestHelper.apiPost({
              endpoint: Endpoints.BILLING_PROFILE_PURCHASE,
              body: args,
              logJSON: true
            });

          case 2:
            response = _context.sent;
            fetchGameRooms(true);
            return _context.abrupt("return", response['0']);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _buyItemWithBillingProfile.apply(this, arguments);
}

export default buyItemWithBillingProfile;